
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]",
      function () {
        return require("private-next-pages/[pillar]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]"])
      });
    }
  